export const TODAY_TITLE = 'Today';

export const CLICK_EVENT = 'click';
export const KEYDOWN_EVENT = 'keydown';

export const DATE_PATTERN = /(?:\d{1,2}|\d{4}|\w+)([\.,\/\\\- ]|$)/g;

export const ARROWS_KEY_CODES = [37,38,39,40];
